/* =============================================================================
   bc-atc.js — Add-to-Cart handler with global cart overlay
   Usage: add data-bc-atc to any ATC <form>; load this file in the section.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__bcAtcLoaded) return;
  window.__bcAtcLoaded = true;

  /* ── Overlay ─────────────────────────────────────────────────────────────── */
  var overlay = null;

  function initOverlay() {
    if (overlay) return;

    var style = document.createElement('style');
    style.textContent =
      '#bc-cart-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;align-items:center;justify-content:center;}' +
      '#bc-cart-overlay.active{display:flex;}' +
      '#bc-cart-overlay .spinner{width:5rem;height:5rem;}' +
      '#bc-cart-overlay .path{stroke:#fff;}';
    document.head.appendChild(style);

    overlay = document.createElement('div');
    overlay.id = 'bc-cart-overlay';
    overlay.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">' +
      '<circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';
    document.body.appendChild(overlay);
  }

  function showOverlay() { initOverlay(); overlay.classList.add('active'); }
  function hideOverlay() { if (overlay) overlay.classList.remove('active'); }

  window.bcCartOverlay = { show: showOverlay, hide: hideOverlay };

  function notifyCartUpdated(cartData) {
    document.dispatchEvent(new CustomEvent('bc:cart-updated', { detail: { cartData: cartData } }));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bc-atc', cartData: cartData });
    }
  }

  function fetchAndNotify() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) { notifyCartUpdated(cartData); });
  }

  /* ── Drawer-upsell attribution ──────────────────────────────────────────── */
  /* Only data-bc-track-upsell forms (drawer upsell cards) reach this. */
  var upsellQueue = Promise.resolve();
  function enqueueUpsellUpdate(fn) {
    upsellQueue = upsellQueue.then(fn).catch(function (err) {
      console.error('[bc-atc] drawer-upsell queue error', err);
    });
    return upsellQueue;
  }

  function trackUpsellPurchase(sku) {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.attributes && cart.attributes['drawer-upsell']) || '';
        var skus = existing.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (skus.indexOf(sku) === -1) skus.push(sku);

        var attributes = {};
        for (var key in cart.attributes) {
          if (Object.prototype.hasOwnProperty.call(cart.attributes, key)) attributes[key] = cart.attributes[key];
        }
        attributes['drawer-upsell'] = skus.join(', ');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function (err) {
        console.error('[bc-atc] drawer-upsell tracking failed', err);
      });
  }

  /* Strips a SKU from drawer-upsell once it's removed from the cart. */
  function reconcileUpsellAttribute() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.attributes && cart.attributes['drawer-upsell']) || '';
        if (!existing) return;

        var tracked = existing.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var cartSkus = cart.items.map(function (i) { return i.sku; });
        var remaining = tracked.filter(function (sku) { return cartSkus.indexOf(sku) !== -1; });
        if (remaining.length === tracked.length) return;

        var attributes = {};
        for (var key in cart.attributes) {
          if (Object.prototype.hasOwnProperty.call(cart.attributes, key)) attributes[key] = cart.attributes[key];
        }
        attributes['drawer-upsell'] = remaining.join(', ');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function (err) {
        console.error('[bc-atc] drawer-upsell reconcile failed', err);
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'bc-atc') return;
      enqueueUpsellUpdate(reconcileUpsellAttribute);
    });
  }

  /* ── Submit handler ──────────────────────────────────────────────────────── */
  /* Capture phase so third-party scripts never intercept our forms. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute('data-bc-atc')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    /* Falls back to a form="<id>"-associated button outside the form. */
    var btn = form.querySelector('[type="submit"]');
    var formIdAttr = form.getAttribute('id');
    if (!btn && formIdAttr) btn = document.querySelector('[type="submit"][form="' + formIdAttr + '"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    if (document.body.hasAttribute('data-cart-busy')) return;
    document.body.setAttribute('data-cart-busy', '');
    btn.setAttribute('aria-disabled', 'true');
    showOverlay();

    var cartDrawer = document.querySelector('cart-drawer');
    var formData = new FormData(form);

    /* Override quantity from our stepper (Kaching Bundles injects its own). */
    var section = form.closest('[data-bc-product-detail]');
    var stepperInput = section && section.querySelector('[data-bc-main-qty-input]');
    if (stepperInput) formData.set('quantity', stepperInput.value || '1');

    /* Pass sections list so the POST response includes rendered HTML. */
    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
    }

    var variantId = parseInt(formData.get('id'), 10);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () {
            throw new Error('Cart error ' + res.status);
          }).then(function (data) {
            throw new Error(data.description || 'Cart add failed');
          });
        }
        return res.json();
      })
      .then(function (response) {
        if (!cartDrawer) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        cartDrawer.renderContents(response);
        fetchAndNotify();

        var upsellSku = form.dataset.bcTrackUpsell;
        if (upsellSku) {
          enqueueUpsellUpdate(function () { return trackUpsellPurchase(upsellSku); });
        }
      })
      .catch(function (err) {
        console.error('[bc-atc]', err.message);
        if (variantId && /(maximum quantity|due to availability)/i.test(err.message)) {
          document.dispatchEvent(new CustomEvent('bc:cart-exhausted', { detail: { variantId: variantId } }));
        }
        fetchAndNotify();
      })
      .finally(function () {
        btn.removeAttribute('aria-disabled');
        hideOverlay();
        document.body.removeAttribute('data-cart-busy');
      });
  }, true);
}());
